import React, { Component } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import Loading from 'components/loading/loading';
import LoginController from 'components/login/login-controller';
import Admin from 'components/admin/admin';

class AdminController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			loadErrMsg: null,
			prevPage: null,
			authData: null,
			games: [],
			players: [],
			gameId: null,
		};

		this.unsubscribeOnAuthStateChanged = null;
	}

	/**
	 * Component mounted
	 */
	componentDidMount() {
		this.checkIfLoggedIn();
	}

	/**
	 * Component will unmount
	 */
	componentWillUnmount = () => {
		/* Unsubscribe  */
		if (this.unsubscribeOnAuthStateChanged !== null) this.unsubscribeOnAuthStateChanged();
	};


	/**
	 * Check if user is logged in
	 */
	checkIfLoggedIn = () => {
		// Unsubscribe previous onAuthStateChanged
		if (this.unsubscribeOnAuthStateChanged !== null) {
			this.unsubscribeOnAuthStateChanged();
		}

		// Subscribe to onAuthStateChanged
		this.unsubscribeOnAuthStateChanged = firebase.auth().onAuthStateChanged((user)=>{
			if (user && user.email !== null) {
				this.setState({
					isLoggedIn: true,
					isLoading: false,
					authData: {id: user.uid, email: user.email}
				});
			} else {
				this.setState({
					isLoading: false,
					isLoggedIn: false,
					authData: null
				});
			}
		});	
	};

	/**
	 * Logout
	 */
	handleLogout = () => {		
		firebase.auth().signOut();
		this.setState({
			isLoading: false,
			isLoggedIn: false,
			authData: null
		});
	};

	/**
	 * Render component
	 */
	render() {
		if (this.state.isLoading) {
			return (
				<Loading languageId={this.props.languageId} />
			);
		};

		if (!this.state.authData) {
			return (
				<LoginController 
					languageId={this.props.languageId}	
					deviceInfo={this.props.deviceInfo}
					scrollToTop={this.props.scrollToTop}
				/>
			);
		}

		return (
			<Admin 
				languageId={this.props.languageId}
				authData={this.state.authData}
				handleLogout={this.handleLogout}
			/>
		);

	}
}

AdminController.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	scrollToTop: PropTypes.func.isRequired,
};

export default AdminController;